module.exports = __webpack_public_path__ + "static/media/Ruzene_Petrov.df06d785.md";